import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { BonusService } from 'src/app/services/bonus/bonus.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';

@Component({
  selector: 'app-redeem-bonus-code',
  templateUrl: './redeem-bonus-code.component.html',
  styleUrls: ['./redeem-bonus-code.component.scss'],
})
export class RedeemBonusCodeComponent implements OnInit {
  @ViewChild(IonContent) content: IonContent;
  @Input() bonusCode;

  public error = null;

  public redeemForm: FormGroup;

  public bonus_code: AbstractControl;

  constructor(
    public successMessageService: SuccessMessageService,
    private bonusService: BonusService,
    private globalErrorHandler: GlobalErrorHandlerService,
    private balanceService: AccountBalanceService
  ) {
    this.successMessageService.clearMessage();
    this.error = null;
  }

  ngOnInit() {
    this.redeemForm = new FormGroup(
      {
        bonus_code: new FormControl('', [Validators.required]),
      }
    );
    this.bonus_code = this.redeemForm.get('bonus_code');
    if (this.bonusCode) this.redeemForm.patchValue({ bonus_code: this.bonusCode });

    this.balanceService.updateBalance();
  }

  onSubmit() {
    this.error = null;
    this.successMessageService.clearMessage();
    this.bonusService.callRedeemBonus(this.redeemForm.get("bonus_code").value).subscribe({
      next: (response: any) => {
        if (response && !!response.result) {
          this.bonus_code.setValue('');
          this.bonus_code.markAsPristine();

          this.successMessageService.setMessage('Your code was redeemed.');

          this.content.scrollToTop();
        }
        // this.bannerProvider.fetchAllBanners();
      },
      error: (error) => {
        this.globalErrorHandler.setErrorCode(error.getErrorCode().toUpperCase());

        switch (error.getErrorCode().toUpperCase()) {
          case 'WRONG_BONUS_CODE':
            error.setErrorMessage('The bonus code is wrong or expired, please try another one.');
            break;
        }
        this.error = error;
        this.content.scrollToTop();
      }
    });
  }
}
